import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addressLine1Required: {
    description: 'Error when address line 1 is missing from blacklist address',
    defaultMessage: 'Address Line 1 is required',
    id: 'WnRGs6',
  },
  cityRequired: {
    description: 'Error when city is missing from blacklist address',
    defaultMessage: 'City is required',
    id: 'dTTKt4',
  },
  stateRequired: {
    description: 'Error when state is missing from blacklist address',
    defaultMessage: 'State is required',
    id: 'fobeac',
  },
  postalCodeRequired: {
    description: 'Error when postal code is missing from blacklist address',
    defaultMessage: 'Postal Code is required',
    id: 'XOthZR',
  },
  countryCodeRequired: {
    description: 'Error when country is missing from blacklist address',
    defaultMessage: 'Country is required',
    id: 'fMJJnK',
  },
  reasonMaxLength: {
    description: 'Error when reason exceeds maximum length',
    defaultMessage: 'Reason must be 500 characters or less',
    id: 'rx4F5M',
  },
});
